import React, { useEffect } from 'react';
import styled from 'styled-components';
import PurchasePreview from '../../../ShutterStock/components/PurchasePreview';
import PurchaseInfo from '../PurchaseInfo';
import actions, { types as ats } from '../../actions';
import { useSelectedAsset } from '../../selectors';

const SummaryBox = styled.div`
  height: 100%;
  display: flex;
  flex-wrap: wrap;
  overflow: auto;
  .preview {
    max-width: 100%;
    max-height: 100%;
  }
`;

const { [ats.SELECT_ASSETS_FORMAT]: selectAssetFormatAction } = actions.creators;

export default ({ retrieveAsset }) => {
  const { selectedAsset } = useSelectedAsset();

  useEffect(() => {
    if (selectedAsset.id) {
      retrieveAsset({ id: selectedAsset.id });
    }
  }, [retrieveAsset, selectedAsset.id]);

  return (
    <SummaryBox>
      <PurchasePreview asset={{ ...selectedAsset, link: selectedAsset.regular_image }} />
      <PurchaseInfo selectAssetFormat={selectAssetFormatAction} />
    </SummaryBox>
  );
};
